var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBubbleMapcolors(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 975 561",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    stroke: "#aeaeae",
    strokeMiterlimit: 10,
    d: "M975.4 460.65l.34-.2a30.2 30.2 0 0015.12-26.18v-.4a30.31 30.31 0 0115.13-26.2l.34-.2a30.25 30.25 0 0130.24 0l.35.2a30.21 30.21 0 0030.22 0l.35-.2a30.25 30.25 0 0130.24 0l.35.2a30.18 30.18 0 0030.24 0l.35-.2a30.21 30.21 0 0130.22 0l.35.2a30.18 30.18 0 0030.24 0l.34-.2a30.2 30.2 0 0015.12-26.17v-.41a30.26 30.26 0 0115.12-26.17l.35-.2a30.27 30.27 0 0015.12-26.2v-.4a30.22 30.22 0 0115.1-26.18l.35-.2a30.2 30.2 0 0015.12-26.18V275a30.24 30.24 0 0115.12-26.19l.35-.2a30.24 30.24 0 0015.12-26.18V222a30.2 30.2 0 00-15.12-26.18l-.35-.2a30.25 30.25 0 00-30.24 0l-.35.2a30.21 30.21 0 01-30.22 0l-.35-.2a30.25 30.25 0 00-30.24 0l-.51.29a30.25 30.25 0 01-30 .15l-1-.59a30.25 30.25 0 00-30.24.3h0a30.24 30.24 0 00-14.86 26v.6a30.24 30.24 0 01-15.12 26.18l-.35.2a30.25 30.25 0 01-30.24 0l-.35-.2a30.21 30.21 0 00-30.22 0l-.35.2a30.29 30.29 0 00-15.13 26.25v.4a30.2 30.2 0 01-15.12 26.18l-.34.2a30.24 30.24 0 00-15.13 26.18v.4a30.27 30.27 0 01-15.12 26.2l-.34.2a30.22 30.22 0 00-15.11 26.17v.41a30.2 30.2 0 01-15.12 26.17l-.34.2a30.27 30.27 0 00-15.12 26.2v.4a30.2 30.2 0 0015.12 26.18l.34.2a30.23 30.23 0 0030.23 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    stroke: "#aeaeae",
    strokeMiterlimit: 10,
    d: "M700.23 407.64l.22-.13a30.43 30.43 0 0130.37 0l.2.13a30.36 30.36 0 0030.37 0l.22-.13a30.43 30.43 0 0130.37 0l.22.13a30.36 30.36 0 0115.17 26.3v.26a30.35 30.35 0 0015.2 26.28l.2.13A30.38 30.38 0 01838 486.92v.23a30.4 30.4 0 0015.18 26.31l.22.13a30.4 30.4 0 0115.19 26.28v.26a30.35 30.35 0 01-15.19 26.3l-.22.13A30.37 30.37 0 00838 592.85v.25a30.38 30.38 0 01-15.19 26.31l-.2.11a30.3 30.3 0 01-30.37 0l-.22-.11a30.3 30.3 0 00-30.37 0l-.22.11a30.35 30.35 0 00-15.17 26.38v.25A30.33 30.33 0 01731 672.44l-.2.13a30.43 30.43 0 01-30.37 0l-.29-.17a30.44 30.44 0 00-30.48 0h0a30.37 30.37 0 01-30.48 0h-.12a30.43 30.43 0 00-30.37 0l-.22.13a30.43 30.43 0 01-30.37 0l-.22-.13a30.43 30.43 0 00-30.37 0l-.2.13a30.43 30.43 0 01-30.37 0l-.22-.13a30.41 30.41 0 00-30.36 0l-.23.13a30.41 30.41 0 01-30.36 0l-.2-.13a30.3 30.3 0 01-15.2-26.28v-.22a30.36 30.36 0 0115.2-26.31l.2-.11a30.34 30.34 0 0130.36 0l.23.11a30.28 30.28 0 0030.36 0l.22-.11a30.36 30.36 0 0130.37 0l.2.11a30.3 30.3 0 0030.37 0l.22-.11a30.38 30.38 0 0015.19-26.3v-.37a30.4 30.4 0 0115.18-26.3l.22-.11a30.3 30.3 0 0130.37 0l.2.11a30.36 30.36 0 0030.37 0l.22-.13a30.44 30.44 0 0015.19-26.3v-.26a30.33 30.33 0 0115.17-26.29l.22-.12a30.34 30.34 0 0015.18-26.31v-.24a30.34 30.34 0 00-15.18-26.3l-.22-.13a30.33 30.33 0 01-15.17-26.29v-.25a30.38 30.38 0 0115.17-26.25z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    stroke: "#aeaeae",
    strokeMiterlimit: 10,
    d: "M654.47 169.34v-.25a30.33 30.33 0 00-15.17-26.29l-.24-.13a30.26 30.26 0 00-30.35 0l-.22.13a30.43 30.43 0 01-30.37 0l-.22-.13a30.26 30.26 0 00-30.35 0l-.24.13a30.33 30.33 0 00-15.17 26.29v.25A30.39 30.39 0 01517 195.59l-.22.13a30.33 30.33 0 00-15.13 26.34v.26a30.31 30.31 0 0015.13 26.36l.22.12a30.31 30.31 0 0030.41-.12l.24-.13a30.39 30.39 0 0130.35 0l.22.13A30.44 30.44 0 01593.37 275v.26a30.37 30.37 0 01-15.19 26.28l-.22.13a30.37 30.37 0 00-15.18 26.29v.25a30.36 30.36 0 01-15.17 26.31l-.24.13a30.39 30.39 0 01-30.35 0l-.22-.13a30.3 30.3 0 00-30.37 0l-.22.13A30.3 30.3 0 00471 380.91v.26a30.34 30.34 0 01-15.2 26.34l-.24.13a30.26 30.26 0 01-30.35 0l-.21-.13a30.43 30.43 0 00-30.37 0l-.22.13a30.4 30.4 0 00-15.18 26.3v.26a30.37 30.37 0 0015.18 26.28l.22.13a30.36 30.36 0 0030.37 0l.21-.13a30.39 30.39 0 0130.35 0l.24.13a30.33 30.33 0 0030.35 0l.22-.13a30.43 30.43 0 0130.37 0l.22.13a30.33 30.33 0 0115.17 26.29v.26a30.42 30.42 0 0015.2 26.3l.24.13a30.39 30.39 0 0030.35 0l.22-.13a30.28 30.28 0 0130.36 0l.22.13a30.39 30.39 0 0030.35 0l.24-.13a30.4 30.4 0 0015.18-26.3v-.26a30.33 30.33 0 0115.17-26.29l.22-.13a30.32 30.32 0 0015.19-26.28v-.26a30.38 30.38 0 00-15.19-26.3l-.22-.13a30.33 30.33 0 01-15.17-26.29V381a30.37 30.37 0 00-15.18-26.29l-.24-.13a30.36 30.36 0 01-15.17-26.3V328a30.33 30.33 0 0115.12-26.23h0a30.4 30.4 0 0015.19-25.92v-.51a30.4 30.4 0 00-15.17-26.65h0a30.37 30.37 0 01-15.18-26.29v-.26a30.37 30.37 0 0115.18-26.28l.24-.13a30.38 30.38 0 0015.15-26.38z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    stroke: "#aeaeae",
    strokeMiterlimit: 10,
    d: "M853.06 195.59h.15A30.5 30.5 0 01868.48 222h0a30.5 30.5 0 0015.24 26.44h0a30.5 30.5 0 010 52.83 30.47 30.47 0 00-15.24 26.41h0a30.53 30.53 0 01-15.27 26.41h0A30.57 30.57 0 00838 380.55h0A30.52 30.52 0 01822.71 407h0a30.49 30.49 0 01-30.51 0 30.51 30.51 0 00-30.52 0h0a30.46 30.46 0 01-30.49 0h0a30.51 30.51 0 00-30.52 0h0a30.52 30.52 0 01-45.76-26.43h0a30.52 30.52 0 00-15.25-26.44h0a30.49 30.49 0 01-15.26-26.43h0a30.45 30.45 0 0114.75-25.94h0a30.51 30.51 0 0015.25-26.41h0a30.56 30.56 0 00-15.18-26.67h0A30.52 30.52 0 01624 222.24h0a30.52 30.52 0 0115.26-26.43h0a30.48 30.48 0 0130.5 0h0a30.49 30.49 0 0030.51 0 30.51 30.51 0 0130.52 0 30.46 30.46 0 0030.49 0h0a30.47 30.47 0 0015.27-26.41 30.52 30.52 0 0115.21-26.4h0a30.48 30.48 0 0130.5 0h0a30.53 30.53 0 0115.26 26.31v.33a30.52 30.52 0 0015.54 26z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    stroke: "#aeaeae",
    strokeMiterlimit: 10,
    d: "M853.06 89.62l.48.28A30.1 30.1 0 01868.6 116v.55a30.13 30.13 0 0015 26.09l.48.27a30.14 30.14 0 0030.11 0l.46-.27a30.07 30.07 0 0130.11 0l.47.27a30.15 30.15 0 0030.12 0l.47-.27a30.13 30.13 0 0015-26.09V116A30.08 30.08 0 011006 89.9l.45-.28a30.14 30.14 0 0130.11 0l.48.28a30.14 30.14 0 0115.06 26.1v.55a30.09 30.09 0 0015 26.09l.48.27a30.09 30.09 0 0115.05 26.07v.55a30.08 30.08 0 0015.06 26.08l.46.28a30 30 0 0115.06 26.06v.55a30 30 0 01-15.06 26.07l-.46.27a30.07 30.07 0 01-30.11 0l-.48-.27a30.2 30.2 0 00-30.11 0l-.48.27a30.14 30.14 0 00-15 26.09v.55a30.11 30.11 0 01-15.07 26.07l-.45.27a30.11 30.11 0 00-15.07 26.07v.55a30.13 30.13 0 01-15 26.08l-.47.28a30.06 30.06 0 00-15 26.06v.55a30.11 30.11 0 01-15.07 26.07l-.47.27a30.07 30.07 0 01-30.11 0l-.46-.27a30.2 30.2 0 00-30.11 0l-.48.27a30.07 30.07 0 01-30.11 0l-.48-.27a30.06 30.06 0 01-15-26.07v-.55a30.06 30.06 0 0115-26l.48-.28a30.08 30.08 0 0015.06-26.08v-.55a30.15 30.15 0 0115-26.07l.48-.27a30.11 30.11 0 0015-26.07V275a30.06 30.06 0 00-15-26.08l-.48-.28a30.06 30.06 0 01-15-26.06V222a30 30 0 00-15.06-26.07l-.48-.35a30.11 30.11 0 01-15-26.08v-.74a30.1 30.1 0 00-15.34-26.26h0a30.06 30.06 0 01-15.3-26.2v-.38a30.13 30.13 0 0115.06-26.07l.46-.27a30.07 30.07 0 0130.16 0z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    stroke: "#aeaeae",
    strokeMiterlimit: 10,
    d: "M730.71-69l.42-.24a30.17 30.17 0 0115.09-4 30.14 30.14 0 0115.08 4l.4.24a30.21 30.21 0 0015.1 4 30.2 30.2 0 0015.09-4l.4-.24a30.29 30.29 0 0115.09-4 30.3 30.3 0 0115.1 4l.4.24A30.16 30.16 0 00838-65a30.16 30.16 0 0015.09-4l.42-.24a30.1 30.1 0 0115.07-4 30.1 30.1 0 0115.07 4l.35.24a30.13 30.13 0 0015.08 4 30.13 30.13 0 0015.08-4l.41-.24a30.24 30.24 0 0115.09-4 30.27 30.27 0 0115.09 4l.4.22A30 30 0 00960.29-65a30 30 0 0015.11-4l.38-.22a30.29 30.29 0 0115.09-4 30.3 30.3 0 0115.1 4l.4.24a30.21 30.21 0 0111 11 30.16 30.16 0 014 15.08v.53a30.2 30.2 0 004 15.08 30.21 30.21 0 0011 11l.42.25A30.13 30.13 0 011052 10.09v.49a30.16 30.16 0 01-15 26.12l-.42.24a30.2 30.2 0 00-15.09 26.12v.5a30.16 30.16 0 01-15.08 26.12l-.42.24A30.2 30.2 0 00990.86 116v.49a30.11 30.11 0 01-15.06 26.1h0a30.13 30.13 0 01-29.56.35l-1.67-.91a30.12 30.12 0 00-29.54.34l-.83.48a30.16 30.16 0 01-30.16 0l-.43-.26a30.16 30.16 0 01-15.06-26.1V116a30.16 30.16 0 00-15.08-26.12l-.42-.24a30.12 30.12 0 00-30.17 0l-.42.24a30.25 30.25 0 01-30.17 0l-.42-.24a30.21 30.21 0 01-15.07-26.08v-.5a30.16 30.16 0 00-15.08-26.12l-.42-.24a30.16 30.16 0 01-15.08-26.12v-.49A30.16 30.16 0 00731.13-16l-.42-.25a30.25 30.25 0 01-11-11 30.1 30.1 0 01-4-15.08v-.49a30.09 30.09 0 014-15.1 30.14 30.14 0 0111-11.08z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    stroke: "#aeaeae",
    strokeMiterlimit: 10,
    d: "M669.76-228.1A30.64 30.64 0 01681-216.91a30.57 30.57 0 014.11 15.28 30.61 30.61 0 004.09 15.29 30.74 30.74 0 0011.19 11.2h0a30.48 30.48 0 0111.22 11.24 30.53 30.53 0 014.07 15.35h0a30.66 30.66 0 004.1 15.3 30.59 30.59 0 0011.2 11.19h0a30.59 30.59 0 0111.19 11.2 30.62 30.62 0 014.1 15.29h0a30.72 30.72 0 01-4.1 15.28 30.64 30.64 0 01-11.24 11.19h0a30.59 30.59 0 00-11.2 11.19 30.66 30.66 0 00-4.1 15.3h0a30.52 30.52 0 004.1 15.29 30.59 30.59 0 0011.2 11.19h0a30.62 30.62 0 0115.29 26.49 30.55 30.55 0 0015.32 26.43h0a30.6 30.6 0 0115.3 26.49h0a30.59 30.59 0 0015.29 26.47 30.58 30.58 0 0115.28 26.49h0a30.58 30.58 0 01-15.28 26.49 30.59 30.59 0 00-15.29 26.48h0a30.57 30.57 0 01-15.3 26.49h0a30.54 30.54 0 01-30.57 0h0a30.64 30.64 0 00-30.59 0h0a30.58 30.58 0 01-30.59 0h0a30.55 30.55 0 01-15.28-26.49 30.59 30.59 0 00-15.29-26.48h0a30.64 30.64 0 01-15.28-26.49h0a30.57 30.57 0 0115.3-26.49 30.59 30.59 0 0015.29-26.47h0a30.58 30.58 0 0115.28-26.49h0a30.57 30.57 0 000-53h0a30.61 30.61 0 00-30.57 0A30.61 30.61 0 01624-12.09a30.65 30.65 0 01-15.3-4.09h0a30.66 30.66 0 01-11.19-11.2 30.61 30.61 0 01-4.09-15.29h0A30.53 30.53 0 00589.26-58a30.59 30.59 0 00-11.19-11.2h0a30.53 30.53 0 01-11.19-11.18 30.52 30.52 0 01-4.1-15.29h0a30.64 30.64 0 014.09-15.29 30.59 30.59 0 0111.2-11.19h0a30.65 30.65 0 0011.15-11.18 30.5 30.5 0 004.09-15.26h0a30.55 30.55 0 014.1-15.29A30.49 30.49 0 01608.6-175h0a30.58 30.58 0 0011.22-11.25 30.5 30.5 0 004.06-15.35h0a30.63 30.63 0 014.12-15.32 30.61 30.61 0 0111.2-11.2h0a30.7 30.7 0 0115.28-4.08 30.62 30.62 0 0115.28 4.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    stroke: "#aeaeae",
    strokeMiterlimit: 10,
    d: "M822.11 407.87l.17-.09a30.39 30.39 0 0130.42 0l.16.09a30.41 30.41 0 0030.43 0l.14-.09a30.39 30.39 0 0130.42 0l.17.09a30.41 30.41 0 0115.21 26.36v.18a30.43 30.43 0 0015.21 26.34h.17a30.46 30.46 0 0115.21 26.34v.18A30.41 30.41 0 00975 513.63l.15.09a30.46 30.46 0 0115.21 26.35v.18a30.41 30.41 0 0015.21 26.36h.17a30.52 30.52 0 0030.42 0h.16a30.37 30.37 0 0130.41 0h.16a30.42 30.42 0 0115.21 26.45v.18a30.41 30.41 0 0015.22 26.34l.16.1a30.46 30.46 0 0030.42 0l.17-.1a30.52 30.52 0 0130.42 0l.15.1a30.46 30.46 0 0115.24 26.32v.19a30.43 30.43 0 01-15.21 26.34h-.15a30.39 30.39 0 01-30.42 0l-.33-.18a30.38 30.38 0 00-30.19-.13h0a30.44 30.44 0 00-15.45 26.48v.37a30.43 30.43 0 01-15.21 26.34l-.14.09a30.41 30.41 0 01-30.43 0l-.16-.09a30.46 30.46 0 01-15.2-26.21v-.18a30.41 30.41 0 00-15.21-26.36h-.16a30.39 30.39 0 00-30.42 0h-.15a30.39 30.39 0 01-30.42 0h-.17a30.39 30.39 0 00-30.42 0h-.17a30.39 30.39 0 01-30.42 0h-.15a30.37 30.37 0 01-15.21-26.34v-.2a30.44 30.44 0 00-15.21-26.37l-.16-.09a30.41 30.41 0 01-15.22-26.34v-.29a30.41 30.41 0 0115.22-26.34l.16-.11a30.37 30.37 0 0015.21-26.34v-.18a30.41 30.41 0 00-15.21-26.35l-.16-.09a30.44 30.44 0 01-15.22-26.36v-.18a30.43 30.43 0 00-15.21-26.34h-.16a30.46 30.46 0 01-15.21-26.34v-.19a30.42 30.42 0 0115.19-26.37z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    stroke: "#aeaeae",
    strokeMiterlimit: 10,
    d: "M960.68 487.21A30.53 30.53 0 00976 513.68h0a30.55 30.55 0 0115.28 26.48h0a30.57 30.57 0 0015.28 26.47h0a30.48 30.48 0 0030.57 0h0a30.64 30.64 0 0130.59 0h0a30.62 30.62 0 0115.28 26.49h0a30.64 30.64 0 0015.28 26.49h0a30.61 30.61 0 0030.57 0 30.58 30.58 0 0130.59 0h0a30.57 30.57 0 0045.85-26.49h0a30.62 30.62 0 0115.29-26.49h0a30.54 30.54 0 0015.3-26.47h0a30.59 30.59 0 0115.29-26.48h0a30.55 30.55 0 0015.28-26.47 30.61 30.61 0 0115.28-26.47h0a30.53 30.53 0 0015.27-26.47h0a30.56 30.56 0 00-45.85-26.47h0a30.64 30.64 0 01-30.59 0 30.54 30.54 0 00-30.57 0h0a30.61 30.61 0 01-30.57 0h0a30.58 30.58 0 00-30.59 0h0a30.61 30.61 0 01-30.57 0h0a30.54 30.54 0 00-30.57 0h0a30.64 30.64 0 01-30.59 0 30.54 30.54 0 00-30.57 0h0a30.61 30.61 0 00-15.28 26.47h0A30.55 30.55 0 01976 460.74h0a30.5 30.5 0 00-15.29 26.47z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M408.51 442.31a7.33 7.33 0 10-7.33-7.33 7.33 7.33 0 007.33 7.33z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M469.68 442.31a7.33 7.33 0 10-7.32-7.33 7.32 7.32 0 007.32 7.33z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M378.87 382.05a.92.92 0 10-.92-.92.92.92 0 00.92.92z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M500.27 389.37a7.32 7.32 0 10-7.32-7.32 7.32 7.32 0 007.32 7.32z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M714.75 555.43a14.65 14.65 0 10-14.64-14.65 14.65 14.65 0 0014.64 14.65z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M530.84 442.31a7.33 7.33 0 10-7.32-7.33 7.33 7.33 0 007.32 7.33z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M592 442.31a7.33 7.33 0 10-7.33-7.33 7.33 7.33 0 007.33 7.33z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M653.17 442.31a7.33 7.33 0 10-7.32-7.33 7.32 7.32 0 007.32 7.33z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M714.75 449.46a14.65 14.65 0 10-14.64-14.64 14.65 14.65 0 0014.64 14.64z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M561.45 494.88a7.33 7.33 0 10-7.33-7.32 7.32 7.32 0 007.33 7.32z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M622.6 494.88a7.33 7.33 0 10-7.32-7.32 7.32 7.32 0 007.32 7.32z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M745.36 502a14.65 14.65 0 10-14.65-14.64A14.64 14.64 0 00745.36 502z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M592 336.8a7.33 7.33 0 10-7.33-7.33 7.33 7.33 0 007.33 7.33z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M655 346a14.65 14.65 0 10-14.64-14.65A14.65 14.65 0 00655 346z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M716.16 346a14.65 14.65 0 10-14.64-14.65A14.64 14.64 0 00716.16 346z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M561.45 389.37a7.32 7.32 0 10-7.33-7.32 7.32 7.32 0 007.33 7.32z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M622.6 389.37a7.32 7.32 0 10-7.32-7.32 7.32 7.32 0 007.32 7.32z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M685.59 398.52A14.65 14.65 0 10671 383.88a14.64 14.64 0 0014.59 14.64z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M746.77 398.52a14.65 14.65 0 10-14.65-14.64 14.65 14.65 0 0014.65 14.64z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M530.84 229.8a7.32 7.32 0 10-7.32-7.32 7.32 7.32 0 007.32 7.32z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M592 229.8a7.32 7.32 0 10-7.33-7.32 7.32 7.32 0 007.33 7.32z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M655 239a14.64 14.64 0 10-14.64-14.64A14.64 14.64 0 00655 239z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M716.16 239a14.64 14.64 0 10-14.64-14.64A14.63 14.63 0 00716.16 239z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M622.6 282.38a7.33 7.33 0 10-7.32-7.33 7.32 7.32 0 007.32 7.33z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M685.59 291.53A14.65 14.65 0 10671 276.88a14.64 14.64 0 0014.59 14.65z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M746.77 291.53a14.65 14.65 0 10-14.65-14.65 14.65 14.65 0 0014.65 14.65z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M653.92 134.39a14.65 14.65 0 10-14.64-14.64 14.65 14.65 0 0014.64 14.64z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M715.08 134.39a14.65 14.65 0 10-14.64-14.64 14.64 14.64 0 0014.64 14.64z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M561.45 176.88a7.32 7.32 0 10-7.33-7.32 7.32 7.32 0 007.33 7.32z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M622.6 176.88a7.32 7.32 0 10-7.32-7.32 7.32 7.32 0 007.32 7.32z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M686.1 184a14.64 14.64 0 10-14.64-14.64A14.64 14.64 0 00686.1 184z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M747.28 184a14.64 14.64 0 10-14.64-14.64A14.63 14.63 0 00747.28 184z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M715.08 28.4a14.64 14.64 0 10-14.64-14.64 14.63 14.63 0 0014.64 14.64z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M684.51 81a14.65 14.65 0 10-14.64-14.65A14.64 14.64 0 00684.51 81z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M745.69 81A14.65 14.65 0 10731 66.33 14.65 14.65 0 00745.69 81z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M775.78 555.43a14.65 14.65 0 10-14.64-14.65 14.64 14.64 0 0014.64 14.65z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M775.78 449.46a14.65 14.65 0 10-14.64-14.64 14.64 14.64 0 0014.64 14.64z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M806.37 502a14.65 14.65 0 10-14.65-14.64A14.64 14.64 0 00806.37 502z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M777.19 346a14.65 14.65 0 10-14.65-14.65A14.64 14.64 0 00777.19 346z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M807.78 398.52a14.65 14.65 0 10-14.65-14.64 14.65 14.65 0 0014.65 14.64z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M777.19 239a14.64 14.64 0 10-14.65-14.64A14.63 14.63 0 00777.19 239z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M807.78 291.53a14.65 14.65 0 10-14.65-14.65 14.65 14.65 0 0014.65 14.65z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M776.11 134.39a14.65 14.65 0 10-14.64-14.64 14.64 14.64 0 0014.64 14.64z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M807.78 186a14.65 14.65 0 10-14.65-14.65A14.65 14.65 0 00807.78 186z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M778.76 17.29a5.49 5.49 0 10-5.49-5.49 5.49 5.49 0 005.49 5.49z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M809.35 69.86a5.49 5.49 0 10-5.49-5.49 5.49 5.49 0 005.49 5.49z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M836.94 555.43a14.65 14.65 0 10-14.65-14.65 14.64 14.64 0 0014.65 14.65z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M899.19 559.09a18.31 18.31 0 10-18.3-18.31 18.31 18.31 0 0018.3 18.31z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M960.37 559.09a18.31 18.31 0 10-18.31-18.31 18.3 18.3 0 0018.31 18.31z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M838 453.12a18.31 18.31 0 10-18.31-18.3 18.3 18.3 0 0018.31 18.3z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M899.19 453.12a18.31 18.31 0 10-18.3-18.3 18.31 18.31 0 0018.3 18.3z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M958.85 451.46a14.65 14.65 0 10-14.64-14.65 14.64 14.64 0 0014.64 14.65z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M868.62 505.69a18.31 18.31 0 10-18.3-18.3 18.3 18.3 0 0018.3 18.3z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M929.8 505.69a18.31 18.31 0 10-18.31-18.3 18.3 18.3 0 0018.31 18.3z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M991.27 513.18a27.46 27.46 0 10-27.46-27.45 27.46 27.46 0 0027.46 27.45z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M838.35 346a14.65 14.65 0 10-14.65-14.7 14.65 14.65 0 0014.65 14.7z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M899.19 336.11a7.32 7.32 0 10-7.32-7.32 7.33 7.33 0 007.32 7.32z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M960.37 336.11a7.32 7.32 0 10-7.32-7.32 7.32 7.32 0 007.32 7.32z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M868.62 388.69a7.33 7.33 0 10-7.32-7.33 7.33 7.33 0 007.32 7.33z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M929.8 388.69a7.33 7.33 0 10-7.32-7.33 7.33 7.33 0 007.32 7.33z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M989.44 398.52a14.65 14.65 0 10-14.65-14.65 14.64 14.64 0 0014.65 14.65z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M838.35 239a14.64 14.64 0 10-14.65-14.64A14.64 14.64 0 00838.35 239z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M899.19 229.12a7.32 7.32 0 10-7.32-7.32 7.33 7.33 0 007.32 7.32z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M960.37 229.12a7.32 7.32 0 10-7.32-7.32 7.32 7.32 0 007.32 7.32z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M868.93 291.53a14.65 14.65 0 10-14.64-14.65 14.65 14.65 0 0014.64 14.65z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M929.8 281.69a7.32 7.32 0 10-7.32-7.32 7.32 7.32 0 007.32 7.32z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M838 123.63a7.33 7.33 0 10-7.32-7.32 7.33 7.33 0 007.32 7.32z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M901.08 123.28a5.49 5.49 0 10-5.49-5.49 5.49 5.49 0 005.49 5.49z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M962.25 123.28a5.49 5.49 0 10-5.49-5.49 5.49 5.49 0 005.49 5.49z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M868.62 176.2a7.32 7.32 0 10-7.32-7.32 7.33 7.33 0 007.32 7.32z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M929.8 176.2a7.32 7.32 0 10-7.32-7.32 7.32 7.32 0 007.32 7.32z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M839.92 17.29a5.49 5.49 0 10-5.49-5.49 5.49 5.49 0 005.49 5.49z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M901.08 17.29a5.49 5.49 0 10-5.49-5.49 5.49 5.49 0 005.49 5.49z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M962.25 17.29a5.49 5.49 0 10-5.49-5.49 5.49 5.49 0 005.49 5.49z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M872.82 70.54a5.49 5.49 0 10-5.5-5.49 5.49 5.49 0 005.5 5.49z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#df4b85",
    d: "M931.68 69.86a5.49 5.49 0 10-5.49-5.49 5.48 5.48 0 005.49 5.49z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M943 230.72l9.06 9.06"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M944.34 206.13l31.06 31.07"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M968.93 204.84l9 9"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M974.16 283.81l9.06 9.06"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M975.45 259.21l31.07 31.07"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M943 336.89l9.1 9.11"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M944.34 312.3l31.06 31.06"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M968.93 311l9 9"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M911.92 390l9.08 9"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M913.22 365.39l31.06 31.06"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M937.81 364.09l9 9"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M913.75 179.47l9.06 9.06"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M915.05 154.88l31.06 31.06"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M939.64 153.58l9 9"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M511 443.06l9.06 9.06"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M512.33 418.47l31.07 31.07"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M536.93 417.18l9 9"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M481.75 390l9.06 9.06"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M483.05 365.39l31.06 31.06"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M507.64 364.09l9 9"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M882.63 230.72l9.07 9.06"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M883.93 206.13L915 237.2"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M908.52 204.84l9 9"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M913.75 283.81l9.06 9.06"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M915.05 259.21l31.06 31.07"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M939.64 257.92l9 9"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M882.63 336.89l9.07 9.11"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M883.93 312.3L915 343.36"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M908.52 311l9 9"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M851.52 390l9.06 9.06"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M852.81 365.39l31.07 31.06"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M877.4 364.09l9 9"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M853.35 179.47l9.06 9.06"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M854.64 154.88l31.07 31.06"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M879.23 153.58l9 9"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M450.63 443.06l9.06 9.06"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M451.93 418.47L483 449.54"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M476.52 417.18l9 9"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M392.06 443.06l9.06 9.06"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M393.35 418.47l31.07 31.07"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M417.94 417.18l9 9"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M573.28 443.06l9.06 9.06"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M574.57 418.47l31.07 31.07"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M599.16 417.18l9 9"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M547.65 498l9.06 9.06"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M548.94 473.39L580 504.45"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M573.54 472.09l9 9"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M544 390l9.06 9.06"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M545.28 365.39l31.07 31.06"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M569.88 364.09l9 9"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M514.7 232.55l9.06 9.07"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M516 208l31.06 31"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M540.59 206.67l9 9"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M545.82 177.64l9.06 9.06"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M547.11 153l31.07 31.07"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M571.71 151.75l9 9"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M633.68 443.06l9.06 9.06"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M635 418.47l31 31.07"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M659.57 417.18l9 9"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M608.06 498l9.06 9.06"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M609.35 473.39l31.07 31.06"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M634 472.09l9 9"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M604.4 390l9.06 9.06"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M605.69 365.39l31.07 31.06"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M630.28 364.09l9 9"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M575.11 232.55l9.06 9.07"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M576.4 208l31.07 31"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M601 206.67l9 9"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M606.23 177.64l9.06 9.06"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M607.52 153l31.07 31.07"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M632.11 151.75l9 9"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M575.11 338.72l9.06 9.07"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M576.4 314.13l31.07 31.07"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M601 312.84l9 9"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M606.23 283.81l9.06 9.06"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M607.52 259.21l31.07 31.07"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M632.11 257.92l9 9"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M822.23 126.39l9.06 9.06"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M823.52 101.79l31.07 31.07"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M848.11 100.5l9 9"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M973.49 59.56v12.81"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M944.21 112.64v12.82"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M953.36 101.66V134"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M962.51 96.17v43.93"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M971.66 101.66V134"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M944.21 6.48v12.81"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M953.36-4.51v32.35"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M962.51-10v43.93"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M971.66-4.51v32.35"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M757.49 114.48v12.81"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M766.65 103.49v32.35"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M775.8 98v43.93"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M785 103.49v32.35"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M794.1 114.48v12.72"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M788.61 378.07v12.81"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M797.77 367.09v32.35"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M806.92 361.6v43.93"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M816.07 367.09v32.35"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M825.22 378.07v12.73"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M819.73 326.82v12.81"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M828.88 315.83v32.35"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M838 310.34v43.93"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M847.19 315.83v32.35"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M856.34 326.82v12.72"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M850.85 271.9v12.81"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M860 260.92v32.35"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M869.16 255.43v43.93"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M878.31 260.92v32.35"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M887.46 271.9v12.73"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M819.73 218.82v12.81"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M828.88 207.83v32.35"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M838 202.34v43.93"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M847.19 207.83v32.35"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M856.34 218.82v12.72"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M788.61 165.73v12.81"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M797.77 154.75v32.35"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M806.92 149.26v43.93"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M816.07 154.75v32.35"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M825.22 165.73v12.73"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M726.38 61.39V74.2"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M735.53 50.41v32.35"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M744.68 44.92v43.93"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M753.83 50.41v32.35"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M763 61.39v12.73"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M728.21 163.9v12.81"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M737.36 152.92v32.35"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M746.51 147.43v43.93"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M755.66 152.92v32.35"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M764.82 163.9v12.73"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M697.09 8.31v12.81"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M706.24-2.68v32.36"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M715.39-8.17v43.93"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M724.54-2.68v32.36"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M733.7 8.31V21"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M913.09 59.56v12.81"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M922.24 48.58v32.35"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M931.39 43.09V87"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M940.54 48.58v32.35"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M949.7 59.56v12.73"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M883.8 112.64v12.82"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M893 101.66V134"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M902.1 96.17v43.93"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M911.26 101.66V134"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M920.41 112.64v12.73"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M882 6.48v12.81"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M891.12-4.51v32.35"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M900.27-10v43.93"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M909.43-4.51v32.35"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M918.58 6.48V19.2"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M697.09 114.48v12.81"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M706.24 103.49v32.35"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M715.39 98v43.93"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M724.54 103.49v32.35"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M733.7 114.48v12.72"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M728.21 378.07v12.81"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M737.36 367.09v32.35"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M746.51 361.6v43.93"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M755.66 367.09v32.35"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M764.82 378.07v12.73"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M759.32 326.82v12.81"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M768.48 315.83v32.35"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M777.63 310.34v43.93"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M786.78 315.83v32.35"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M795.93 326.82v12.72"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M819.73 535.49v12.82"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M828.88 524.51v32.35"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M838 519v44"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M847.19 524.51v32.35"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M856.34 535.49v12.73"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M942.38 535.49v12.82"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M951.53 524.51v32.35"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M960.68 519v44"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M969.83 524.51v32.35"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M911.26 482.41v12.81"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M920.41 471.42v32.36"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M929.56 465.93v43.94"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M938.71 471.42v32.36"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M947.87 482.41v12.73"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M788.61 482.41v12.81"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M797.77 471.42v32.36"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M806.92 465.93v43.94"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M816.07 471.42v32.36"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M825.22 482.41v12.73"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M880.14 429.32v12.82"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M889.29 418.34v32.35"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M898.44 412.85v43.93"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M907.59 418.34v32.35"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M916.75 429.32v12.73"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M757.49 429.32v12.82"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M766.65 418.34v32.35"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M775.8 412.85v43.93"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M785 418.34v32.35"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M794.1 429.32v12.73"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M790.44 271.9v12.81"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M799.59 260.92v32.35"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M808.75 255.43v43.93"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M817.9 260.92v32.35"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M827.05 271.9v12.73"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M759.32 218.82v12.81"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M768.48 207.83v32.35"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M777.63 202.34v43.93"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M786.78 207.83v32.35"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M795.93 218.82v12.72"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M666 61.39V74.2"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M675.12 50.41v32.35"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M684.27 44.92v43.93"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M693.42 50.41v32.35"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M702.58 61.39v12.73"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M667.8 163.9v12.81"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M677 152.92v32.35"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M686.1 147.43v43.93"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M695.26 152.92v32.35"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M704.41 163.9v12.73"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M854.51 59.56v12.81"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M863.66 48.58v32.35"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M872.82 43.09V87"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M882 48.58v32.35"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M891.12 59.56v12.73"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M821.56 6.48v12.81"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M830.71-4.51v32.35"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M839.87-10v43.93"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M849-4.51v32.35"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M858.17 6.48V19.2"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M790.44 59.56v12.81"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M799.59 48.58v32.35"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M808.75 43.09V87"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M817.9 48.58v32.35"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M827.05 59.56v12.73"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M761.15 6.48v12.81"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M770.31-4.51v32.35"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M779.46-10v43.93"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M788.61-4.51v32.35"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M797.77 6.48V19.2"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M636.68 114.48v12.81"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M645.83 103.49v32.35"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M655 98v43.93"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M664.14 103.49v32.35"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M673.29 114.48v12.72"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M667.8 378.07v12.81"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M677 367.09v32.35"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M686.1 361.6v43.93"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M695.26 367.09v32.35"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M704.41 378.07v12.73"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M698.92 326.82v12.81"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M708.07 315.83v32.35"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M717.22 310.34v43.93"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M726.38 315.83v32.35"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M735.53 326.82v12.72"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M759.32 535.49v12.82"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M768.48 524.51v32.35"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M777.63 519v44"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M786.78 524.51v32.35"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M795.93 535.49v12.73"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M880.14 535.49v12.82"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M889.29 524.51v32.35"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M898.44 519v44"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M907.59 524.51v32.35"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M916.75 535.49v12.73"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M850.85 482.41v12.81"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M860 471.42v32.36"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M869.16 465.93v43.94"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M878.31 471.42v32.36"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M887.46 482.41v12.73"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M728.21 482.41v12.81"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M737.36 471.42v32.36"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M746.51 465.93v43.94"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M755.66 471.42v32.36"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M764.82 482.41v12.73"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M819.73 429.32v12.82"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M828.88 418.34v32.35"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M838 412.85v43.93"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M847.19 418.34v32.35"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M856.34 429.32v12.73"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M697.09 429.32v12.82"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M706.24 418.34v32.35"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M715.39 412.85v43.93"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M724.54 418.34v32.35"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M733.7 429.32v12.73"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M730 271.9v12.81"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M739.19 260.92v32.35"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M748.34 255.43v43.93"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M757.49 260.92v32.35"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M766.65 271.9v12.73"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M698.92 218.82v12.81"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M708.07 207.83v32.35"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M717.22 202.34v43.93"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M726.38 207.83v32.35"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M735.53 218.82v12.72"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M636.68 326.82v12.81"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M645.83 315.83v32.35"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M655 310.34v43.93"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M664.14 315.83v32.35"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M673.29 326.82v12.72"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M697.09 535.49v12.82"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M706.24 524.51v32.35"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M715.39 519v44"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M724.54 524.51v32.35"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M733.7 535.49v12.73"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M940.54 431.15V444"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M949.7 420.17v32.35"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M958.85 414.68v43.93"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M968 420.17v32.35"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M971.66 378.07v12.81"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M667.8 271.9v12.81"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M677 260.92v32.35"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M686.1 255.43v43.93"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M695.26 260.92v32.35"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M704.41 271.9v12.73"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M636.68 218.82v12.81"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M645.83 207.83v32.35"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M655 202.34v43.93"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M664.14 207.83v32.35"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M673.29 218.82v12.72"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M981 466.25l-8.82 9.29"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M992.72 464.1l-22.5 23.25"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M999.65 467l-26.51 27.36"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2c2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M1006.67 469.87l-31.06 31.06"
  })));
}

export default __webpack_public_path__ + "bubble-map.colors.51b292e2.svg";
export { SvgBubbleMapcolors as ReactComponent };